import React from 'react';

export const BackArrow = React.memo(({ fill }) => (
  <>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M25 15C25 15.3409 24.8683 15.6679 24.6339 15.909C24.3995 16.15 24.0816 16.2855 23.7501 16.2855H9.26926L14.6362 21.8028C14.7524 21.9223 14.8445 22.0642 14.9074 22.2203C14.9703 22.3765 15.0027 22.5439 15.0027 22.7129C15.0027 22.8819 14.9703 23.0493 14.9074 23.2054C14.8445 23.3616 14.7524 23.5035 14.6362 23.623C14.52 23.7425 14.382 23.8373 14.2302 23.902C14.0783 23.9667 13.9156 24 13.7513 24C13.5869 24 13.4242 23.9667 13.2724 23.902C13.1205 23.8373 12.9826 23.7425 12.8664 23.623L5.36719 15.9101C5.2508 15.7907 5.15845 15.6489 5.09544 15.4927C5.03243 15.3365 5 15.1691 5 15C5 14.8309 5.03243 14.6635 5.09544 14.5073C5.15845 14.3511 5.2508 14.2093 5.36719 14.0899L12.8664 6.37698C13.101 6.13561 13.4194 6 13.7513 6C14.0832 6 14.4015 6.13561 14.6362 6.37698C14.8708 6.61836 15.0027 6.94574 15.0027 7.28711C15.0027 7.62847 14.8708 7.95585 14.6362 8.19723L9.26926 13.7145H23.7501C24.0816 13.7145 24.3995 13.85 24.6339 14.091C24.8683 14.3321 25 14.6591 25 15Z'
      fill={fill}
    />
  </>
));
BackArrow.displayName = 'BackArrow';
